import Loading from "components/Loading";
import Permission from "components/Permission";
import PermissionDeniedPage from "components/PermissionDenied";
import React, { Suspense } from "react";
import { Route } from "react-router-dom";
import { MODULE_DISTRICT } from "shared/constants";

const District = React.lazy(() => import("containers/AreaManagement/District"));

const DistrictRoute = () => {
  return (
    <Route
      path="district"
      element={
        <Suspense fallback={<Loading loading />}>
          <Permission
            children={<District />}
            permissionDenied={<PermissionDeniedPage />}
            modules={[MODULE_DISTRICT]}
          />
        </Suspense>
      }
    />
  );
};

export default DistrictRoute;
